<emoji-picker (emoji-click)="emojiClicked($event)"></emoji-picker>
